import React, { Component } from "react";
import { Wrapper } from "app/NativeComponents/common";

import { AppConfig } from "app/NativeActions";

import ReactGA from "react-ga";
import ReactPixel from "react-facebook-pixel";

ReactGA.initialize(AppConfig().google_analytics, {
  siteSpeedSampleRate: 100
});

ReactPixel.init(
  AppConfig().facebook_pixel,
  {},
  {
    autoConfig: true, // set pixel's autoConfig
    debug: false // enable logs
  }
);

class AnalyticsWrapper extends Component {
  registerGA(user) {
    if (user) {
      ReactGA.set({ userId: user.id });
    }
  }

  componentDidMount() {
    this.registerGA(this.props.user);
  }

  componentDidUpdate(prevProps) {
    if (this.props.user) {
      if (this.props.user != prevProps.user || prevProps.user == null) {
        this.registerGA(this.props.user);
      }
    }

    if (
      this.props.trackingEvent != null &&
      this.props.trackingEvent != prevProps.trackingEvent
    ) {
      /* this is now going through Segment */

      this.props.setTrackingEvent(null);
    }
  }

  render() {
    return <Wrapper />;
  }
}

export default AnalyticsWrapper;
